var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon",class:_vm.size},[(_vm.mySvg)?_c('object',{attrs:{"data":_vm.mySvg,"type":"image/svg+xml"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }